import { render } from "./IncidentView.vue?vue&type=template&id=4f39fb36&scoped=true"
import script from "./IncidentView.vue?vue&type=script&lang=js"
export * from "./IncidentView.vue?vue&type=script&lang=js"

import "./IncidentView.vue?vue&type=style&index=0&id=4f39fb36&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f39fb36"]])

export default __exports__